<div class="headline-4 px-3 my-3">Bidders</div>
@if(!notDeletedOptions || notDeletedOptions.length === 0){
    <div class="text-center p-3">No available options yet.</div>
} @else if(!aggregatedBids || aggregatedBids.length ===0){
    <div class="text-center p-3">No bids made yet.</div>
} @else{
    <div class="table--paybee" >
        <table class="table" cellspacing="0" style="width: 100%; background-color: white;"
            datatable #biddersDatatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead class="thead-light">
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Address</th>
                <th style="white-space: nowrap;">Bids Placed</th>
                <th style="white-space: nowrap;">Items won</th>
            </tr>
            </thead>
        </table>
    </div>
}